export enum Period {
  Yearly = 'yearly',
  Monthly = 'monthly'
}
